<!-- eslint-disable vue/max-attributes-per-line -->
<template>
	<v-main
		ref="allContent"
		v-scroll="onScroll"
	>
		<div
			class="full-height pl-sm-12 mx-auto d-flex align-sm-center justify-center"
			style="max-width: 1920px;"
		>
			<div class="d-none d-sm-flex">
				<div class="d-flex flex-column justify-space-around my-9 my-sm-12 py-sm-6 py-md-9 py-lg-12 pr-6 pr-md-12 mr-lg-6 mr-xl-12">
					<p
						class="mt-md-6 mt-lg-12"
						style="font-size: min(3.8vw, 84px); line-height: min(4vw, 86px);"
					>
						<span class="red--text font-weight-black">THE BEST</span><br>
						PROPERTY<br>
						AGENT
					</p>
					<div
						class="text-no-wrap"
						style="font-size: min(2.6vw, 58px); line-height: min(3vw, 64px);"
					>
						“ค้นหาเพื่อส่งมอบสิ่ง<br>ที่ดีที่สุดให้กับลูกค้า”<br>

						<v-btn
							rounded
							color="rgb(237,28,36)"
							colors="#ff0000"
							min-width="88"
							min-height="28"
							width="9vw"
							height="2.5vw"
							class="mt-3 mt-md-6 mb-4 mb-md-6 mb-lg-12"
							style="font-size: max(1vw, 10px); font-weight: bold;"
							dark
							:to="{name: 'index'}"
						>
							ดูเพิ่มเติม
						</v-btn>
					</div>
				</div>
				<div>
					<img
						src="/images/2.0/service/Welcome-01.png"
						style="width: 48vw; max-width: 850px;"
					>
				</div>
			</div>

			<div class="d-sm-none d-flex flex-column justify-center">
				<div>
					<img
						src="/images/2.0/service/Welcome-01.png"
						style="width: 90vw;"
					>
				</div>
				<div
					class="d-flex flex-column text-no-wrap pl-6"
					style="font-size: min(6.2vw, 30px); line-height: min(8vw, 44px);"
				>
					<p
						class="mt-md-6 mt-lg-12"
						style="font-size: min(8.8vw, 50px); line-height: min(9vw, 54px);"
					>
						<span class="red--text font-weight-black">THE BEST</span><br>
						PROPERTY<br>
						AGENT
					</p>

					“ค้นหาเพื่อส่งมอบสิ่ง<br>ที่ดีที่สุดให้กับลูกค้า”<br>

					<v-btn
						rounded
						color="rgb(237,28,36)"
						colors="#ff0000"
						width="26vw"
						height="7vw"
						class="ml-auto"
						style="font-size: max(1vw, 14px); font-weight: bold;"
						dark
						:to="{name: 'index'}"
					>
						ดูเพิ่มเติม
					</v-btn>
				</div>
			</div>
		</div>

		<!--  -->
		<div
			class="our-service mx-auto text-center"
			style="max-width: 1500px;"
		>
			<p style="font-size: clamp(40px, 4vw, 80px); line-height: min(4vw, 80px);">
				Our <span class="red--text font-weight-black">Service</span>
			</p>
			<p style="font-size: 1.5rem; margin: 0 24px 24px 24px; ">
				ฝากขายบ้านกับเรา ดูแลการขายให้จบ ครบทุกขั้นตอน
			</p>
			<v-row
				no-gutters
				class="d-flex justify-center"
			>
				<v-col
					cols="12"
					md="4"
					lg="3"
				>
					<img
						src="/images/2.0/service/Ourservice-01.png"
						alt="ฝากขายอสังหาฯ กับเรา"
					>
					<b>ฝากขายอสังหาฯ กับเรา</b>
					<p>
						พร้อมดูแลการขายอสังหาฯ ให้กับคุณ โดยตัวแทนมืออาชีพ
						<span class="font-weight-black">มากกว่า 1,000 คน</span>
						ด้วยการตลาดที่ครบวงจร ลงประกาศ ขายบนแพลตฟอร์มชั้นนําระดับประเทศ มีฐานลูกค้าพร้อมซื้อจํานวนมาก
					</p>
				</v-col>
				<v-col
					cols="12"
					md="4"
					lg="3"
				>
					<img
						src="/images/2.0/service/Ourservice-02.png"
						alt="เลือกซื้ออสังหาฯ กับเรา"
					>
					<b>เลือกซื้ออสังหาฯ กับเรา</b>
					<p>
						เราคือศูนย์รวมบ้านมือสอง และอสังหาฯ ทุกประเภท ให้คุณได้เลือกเป็นเจ้าของ ได้ง่ายๆ เพราะเรามีบริการจัดสินเชื่อแบบ ครบวงจร ตลอดจนอํานวยความสะดวก ถึงวันโอนกรรมสิทธ์ให้กับผู้ซื้อในทุกขั้นตอน
					</p>
				</v-col>
				<v-col
					cols="12"
					md="4"
					lg="3"
				>
					<img
						src="/images/2.0/service/Ourservice-03.png"
						alt="เป็นตัวแทนกับเรา"
					>
					<b>เป็นตัวแทนกับเรา</b>
					<p>
						ส่งมอบโอกาสธุรกิจนายหน้าอสังหาฯ ให้กับคุณ เริ่มต้นได้ง่ายไม่ต้องลงทุน มี Academy สอนวิธีการทํางานอย่าง มืออาชีพ และ มีระบบ SMART AGENT SYSTEM พร้อมสนับสนุนคุณ
					</p>
				</v-col>
			</v-row>
		</div>

		<!--  -->
		<div>
			<div class="d-sm-none text-right mt-12">
				<div class="pr-6 mb-n6">
					<p style="font-size: 7vw; line-height: 7vw;">
						<span
							class="red--text font-weight-black"
							style="font-size: 9vw; line-height: 9vw;"
						>
							THE BEST
						</span><br>
						PROPERTY AGENT
					</p>
					<p style="font-size: 4.5vw; line-height: 5vw; font-weight: bold;">
						เราคือผู้นําด้านธุรกิจนายหน้าอสังหาริมทรัพย์<br>ชั้นนําของประเทศ ด้วยเทคโนโลยี และนวัตกรรม<br>ที่สร้างสรรค์
					</p>
				</div>
				<img
					src="/images/2.0/service/Vision-01.png"
					alt="Vision & Mission"
					width="100%"
					style="width: 100vw; margin-bottom: -6px;"
				>
			</div>
			<div class="d-none d-sm-flex align-center mt-8">
				<img
					src="/images/2.0/service/Vision-01.png"
					alt="Vision & Mission"
					width="100%"
					style="width: 60vw;"
				>
				<div>
					<p style="font-size: min(3.5vw, 62px); line-height: min(3.5vw, 62px);">
						<span
							class="red--text font-weight-black"
							style="font-size: min(4vw, 82px); line-height: min(5vw, 82px);"
						>
							THE BEST
						</span><br>
						PROPERTY AGENT
					</p>
					<p style="font-size: min(2vw, 42px); line-height: min(3vw, 48px); font-weight: bold; margin-top: min(3vw, 48px);">
						เราคือผู้นําด้านธุรกิจนายหน้าอสังหาริมทรัพย์<br>ชั้นนําของประเทศ ด้วยเทคโนโลยี<br>และนวัตกรรม ที่สร้างสรรค์
					</p>
					<p style="font-size: min(1.8vw, 24px); line-height: min(2vw, 30px); margin-top: min(3vw, 48px);">
						"พร้อมส่งต่อที่อยู่ของความสุขให้คนไทยทุกคน"
					</p>
				</div>
			</div>
			<div class="bg-red py-4 px-4">
				<div style="width: fit-content; margin: 0 auto;">
					<p
						class="white--text ma-0"
						style="font-size: min(6.4vw, 76px); line-height: min(6.8vw, 88px);"
					>
						More 10 YEARS OF EXPERIENCE
					</p>
					<b style="font-size: min(4.6vw, 56px); line-height: min(5vw, 60px);">
						“WE ARE REAL ESTATE EXPERT"
					</b>
				</div>
			</div>
			<div
				class="d-flex mx-auto"
				style="width: min(90vw, 1100px);"
			>
				<div
					class="d-flex flex-column justify-space-around text-no-wrap py-3 py-sm-6 py-md-9"
					style="width: min(60%, 900px);"
				>
					<p style="font-size: min(4.6vw, 56px); line-height: min(5vw, 62px); margin: 0;">
						<b class="red--text">THE BEST</b>
						PROPERTY AGENT
					</p>
					<p style="font-size: min(2.75vw, 30px); line-height: min(3.2vw, 36px); margin: 0; font-weight: bold;">
						เริ่มก่อตั้งเมื่อปี 2557 โดยมีวัตถุประสงค์ที่จะส่งมอบ<br>โอกาสและสนับสนุน ผู้ที่ต้องการทําธุรกิจนายหน้า<br>อสังหาริมทรัพย์ให้ประสบความสําเร็จ
					</p>
					<p style="font-size: min(2.25vw, 27px); line-height: min(3vw, 34px); margin: 0;">
						ยกระดับวงการนายหน้าอสังหาริมทรัพย์<br>ให้มีมาตรฐาน ชื่อสัตย์และเป็นธรรม เพื่อ<br>ส่งต่อที่อยู่ของความสุข นั่นก็คือที่อยู่<br>อาศัย ให้กับผู้จะซื้อ และผู้จะขาย<br>อสังหาริมทรัพย์ทุกคน
					</p>
				</div>
				<div style="width: max(40%, 200px);">
					<img
						src="/images/2.0/service/Vision-02.png"
						alt="Vision & Mission"
						style="width: min(123%, 460px); margin: max(-72px, -8vw) 0px -6px max(-34px, -6vw);"
					>
				</div>
			</div>
		</div>

		<!--  -->
		<div
			class="mx-auto"
			style="max-width: 1920px;"
		>
			<v-parallax
				v-intersect="{
					handler: onIntersect,
					options: {
						threshold: [0, 0.5, 1.0]
					}
				}"
				src="/images/2.0/service/Award-01.png"
				style="max-height: min(20vw, 205px);"
				height="205"
				dark
			>
				<v-row class="align-center">
					<v-col class="flex-grow-0 flex-shrink-1 d-flex align-center pl-md-12 py-0">
						<img
							src="/images/2.0/service/Award-02.png"
							alt="Awards"
							style="width: min(20vw, 200px);"
						>
					</v-col>
					<v-col
						class="flex-grow-1 flex-shrink-0 pl-0"
						style="font-size: min(5.1vw, 74px); line-height: min(5.3vw, 64px);"
					>
						<div style="width: fit-content; margin: 0 auto;">
							<p class="ma-0">
								รางวัล <b>Dot Property Awards</b><br>
								<b style="font-size: min(3.6vw, 64px); line-height: min(4vw, 60px);">
									Thailand’s Best Real Estate Agencies 2023
								</b>
							</p>
						</div>
					</v-col>
				</v-row>
			</v-parallax>

			<v-img
				src="/images/2.0/service/Award-03.jpg"
				width="100%"
				max-width="1920"
				:class="{'fade-in-active': awardImgShow}"
				class="fade-in"
			/>
		</div>

		<!--  -->
		<div
			class="mx-auto"
			style="max-width: 1920px;"
		>
			<v-row class="pa-6 pa-md-12">
				<v-col
					cols="12"
					sm="6"
					class="px-0 d-flex flex-column"
				>
					<div class="d-sm-none text-center">
						<p style="font-size: 12vw; line-height: 12vw;">
							ทําไมต้อง
							<span class="red--text font-weight-black">
								ฝากขาย
							</span><br>
							<span style="font-size: 8vw; line-height: 8vw; display: block;">
								กับ THE BEST PROPERTY
							</span>
						</p>

						<v-img
							src="/images/2.0/service/Marketing-01.png"
							width="100%"
							styles="margin-top: -48px;"
							class="mt-n5"
						/>

						<p style="font-size: 9vw; line-height: 9vw; text-align: center;">
							<span style="font-size: 7.5vw; line-height: 11vw;">
								ให้เราช่วยคุณขาย
							</span><br>
							<span
								class="red--text font-weight-black"
								style="font-size: 10vw; line-height: 10vw;"
							>
								"ไม่เสียค่าใช้จ่าย"
							</span><br>
							จนกว่าจะขายได้
						</p>
					</div>

					<div class="d-none d-sm-block text-center">
						<p style="font-size: min(6vw, 120px); line-height: min(6vw, 120px);">
							ทําไมต้อง
							<span class="red--text font-weight-black">
								ฝากขาย
							</span><br>
							<span style="font-size: min(3.6vw, 74px); line-height: min(3.6vw, 74px); display: block;">
								กับ THE BEST PROPERTY
							</span>
						</p>

						<p style="font-size: min(5.1vw, 104px); line-height: min(5.1vw, 104px);">
							<span style="color: #999; font-size: min(4.5vw, 92px); line-height: min(4.5vw, 92px);">
								ให้เราช่วยคุณขาย
							</span><br>
							<span
								class="red--text font-weight-black"
								style="font-size: min(4.8vw, 98px); line-height: min(4.8vw, 98px);"
							>
								"ไม่เสียค่าใช้จ่าย"
							</span><br>
							จนกว่าจะขายได้
						</p>
					</div>

					<div class="mx-auto d-inline-block mt-auto">
						<v-divider style="width: 80%; border-color: #000; margin: 0 auto;" />
						<v-btn
							rounded
							color="rgb(237,28,36)"
							colors="#ff0000"
							min-width="94"
							min-height="30"
							width="9vw"
							height="2.5vw"
							class="mt-3 mt-md-6 mb-4 mb-md-6 mb-lg-12"
							style="font-size: max(1vw, 12px); font-weight: bold;"
							dark
							:to="{name: 'contact-us'}"
						>
							ติดต่อเรา
						</v-btn>
					</div>
				</v-col>
				<v-col
					cols="12"
					sm="6"
					class="d-none d-sm-block"
				>
					<v-img
						src="/images/2.0/service/Marketing-01.png"
						width="100%"
						style="margin-top: -8vw;"
					/>
				</v-col>
			</v-row>

			<p class="d-sm-none text-center mt-12 px-6">
				<b style="font-size: 8.5vw; line-height: 9vw;">
					<span class="red--text">THE BEST</span>
					MARKETING
				</b>
				<br>
				<b style="font-size: 6.5vw; line-height: 6.5vw;">
					"คนเห็นมาก โอกาส
					<span class="red--text">ขาย</span>
					ก็มาก"
				</b>
				<br>
				"การตลาดออนไลน์ครอบคลุมทุกแพลตฟอร์มชั้นนํา ระดับประเทศ ด้วยงบการตลาด
				<b>มากกว่า 10 ล้านบาทต่อปี</b>
				เข้าถึงผู้ที่ต้องการซื้อ
				<b>มากกว่า 30 ล้าน ยอดชมต่อเดือน</b>"
			</p>
			<v-row class="marketing-02">
				<!-- <v-col cols="6">
					&nbsp;
				</v-col> -->
				<v-col
					cols="6"
					offset="6"
				>
					<p
						class="d-none d-sm-block pr-12 pr-md-12 mr-md-12 mt-sm-1 mt-md-4 mt-lg-6 mt-xl-8"
						style="font-size: min(1.5vw, 32px); line-height: min(1.5vw, 32px);"
					>
						<b style="font-size: min(5vw, 106px); line-height: min(5vw, 106px);">
							<span class="red--text">THE BEST</span><br>
							MARKETING
						</b>
						<br>
						<b style="font-size: min(3.15vw, 68px); line-height: min(3.3vw, 68px); display: block;">
							"คนเห็นมาก โอกาส
							<span class="red--text">ขาย</span>
							ก็มาก"
						</b>
						<br>
						"การตลาดออนไลน์ครอบคลุมทุกแพลตฟอร์มชั้นนํา ระดับประเทศ ด้วยงบการตลาด
						<b>มากกว่า 10 ล้านบาทต่อปี</b>
						เข้าถึงผู้ที่ต้องการซื้อ
						<b>มากกว่า 30 ล้าน ยอดชมต่อเดือน</b>"
					</p>

					<v-row
						no-gutters
						class="ml-sm-n12 pr-6 pr-md-12 mr-md-12"
					>
						<v-col
							cols="12"
							sm="7"
							offset-sm="5"
						>
							<p
								class="d-sm-none"
								style="font-size: 2.5vw; line-height: 2.5vw;"
							>
								จากเว็บไซต์ที่ติด
								<b style="font-size: 5.2vw; line-height:5.2vw; display: block; font-style: italic;">
									Top-ranking
								</b>
								<b style="font-size: 9.2vw; line-height:9.2vw; display: block;">
									ใน
									<span class="red--text">Google</span>
								</b>
							</p>
							<p
								class="d-none d-sm-block my-sm-2 my-md-8 my-lg-12"
								style="font-size: max(1.2vw, 16px); line-height: max(1.2vw, 16px);"
							>
								จากเว็บไซต์ที่ติด
								<b style="font-size: clamp(24px, max(3.25vw, 24px), 48px); line-height: clamp(24px, max(3.25vw, 24px), 48px); display: block; font-style: italic;">
									Top-ranking
								</b>
								<b style="font-size: clamp(34px, max(5.5vw, 34px), 84px); line-height: clamp(34px, max(5.5vw, 34px), 84px); display: block;">
									ใน
									<span class="red--text">Google</span>
								</b>
							</p>
						</v-col>

						<v-col
							cols="12"
							sm="6"
							class="mt-sm-2 mt-lg-6 mt-xl-6 ml-sm-n4 ml-md-n8 ml-lg-n12 d-flex justify-end justify-sm-start"
						>
							<p style="font-size: clamp(12px, 1.2vw, 26px); line-height: clamp(12px, 1.2vw, 26px);">
								การตลาดออนไลน์
								<b style="font-size: clamp(26px, 3vw, 70px); line-height: clamp(26px, 3vw, 70px); display: block;">
									<span class="red--text">18</span>
									ช่องทาง
								</b>
							</p>
						</v-col>
						<v-col
							cols="12"
							sm="6"
							class="mt-n1 mt-sm-2 mt-lg-6 mt-xl-6 ml-sm-n4 ml-md-n8 pl-md-7 pl-xl-1 d-flex justify-end justify-sm-start"
						>
							<p style="font-size: clamp(12px, 1.2vw, 26px); line-height: clamp(12px, 1.2vw, 26px);">
								ยอดชม
								<b style="font-size: clamp(26px, 3vw, 70px); line-height: clamp(26px, 3vw, 70px); display: block;">
									<span class="red--text">30</span>
									ล้านครั้ง
								</b>
							</p>
						</v-col>
					</v-row>
				</v-col>
			</v-row>

			<v-img
				src="/images/2.0/service/Marketing-03.png"
				width="100%"
			/>

			<div class="marketing-04">
				<v-row no-gutters>
					<v-col
						cols="12"
						class="text-center"
					>
						<p
							class="pt-2 pt-sm-4 mb-0"
							style="font-size: clamp(22px, 3.2vw, 74px);"
						>
							<span style="color: #fff; font-size: clamp(24px, 4vw, 78px);">THE BEST</span>
							<b style="color: #fff; font-size: clamp(26px, 4.5vw, 90px);">Offline</b>
							Marketing
						</p>
					</v-col>
					<v-col
						cols="6"
						offset="6"
						class="text-center pt-sm-6 pt-md-12"
					>
						<p style="font-size: clamp(10px, 2.2vw, 54px);">
							การตลาด Offline ครบครัน<br>
							ป้ายฟิวเจอร์บอร์ด และไวนิล
						</p>
					</v-col>
				</v-row>
			</div>

			<v-row
				class="mx-auto pt-2 pt-sm-6 px-4 d-flex align-center justify-center"
				style="max-width: 1700px;"
			>
				<v-col
					cols="12"
					sm="5"
					style="font-size: clamp(14px, 2.2vw, 40px);"
				>
					ป้ายโฆษณาน่าเชื่อถือโดยทีมออกแบบ
					<b
						class="red--text"
						style="font-size: clamp(24px, 4.1vw, 76px); line-height: clamp(24px, 4.1vw, 76px); display: block;"
					>
						และทีมติดตั้งมืออาชีพ
					</b>
				</v-col>
				<v-col
					cols="12"
					sm="7"
					class="d-flex"
				>
					<div class="marketing-stuff flex-grow-1">
						01.
						<b>ป้ายหน้าบ้าน</b>
					</div>
					<div class="marketing-stuff flex-grow-1">
						02.
						<b>ป้ายที่ดิน</b>
					</div>
					<div class="marketing-stuff flex-grow-1">
						03.
						<b>ป้ายเสาไฟฟ้า</b>
					</div>
				</v-col>
			</v-row>

			<div class="marketing-05 mt-n2 mt-md-n4">
				<div
					class="mx-auto px-6 px-sm-12 fill-height d-flex flex-column justify-center"
					style="max-width: 1700px; padding-top: min(6.5vw, 125px) !important;"
				>
					<p
						class="mb-0 mb-sm-4 mb-md-8"
						style="font-size: clamp(26px, 7vw, 130px); line-height: clamp(26px, 5.5vw, 120px); font-weight: bold;"
					>
						THE BEST<br>
						AGENT
						<span class="white--text">Marketing</span>
					</p>
					<p
						class="mb-0 mb-sm-4 mb-md-8"
						style="font-size: clamp(10px, 2.2vw, 42px); line-height: clamp(10px, 2.2vw, 42px); font-weight: bold;"
					>
						ตัวแทน ช่วยกันขายมากกว่า
						<span style="font-size: clamp(22px, 6vw, 130px); line-height: clamp(26px, 4.5vw, 120px); color: #fff;">1,000 คน</span>
					</p>
					<p
						class="mb-0 mb-sm-4 mb-md-8"
						style="font-size: clamp(10px, 3vw, 52px); line-height: clamp(10px, 3vw, 60px);"
					>
						"มีฐานข้อมูลผู้สนใจซื้อจํานวนมาก" <br>
						<span style="font-size: clamp(10px, 2vw, 35px); line-height: clamp(10px, 2vw, 35px);">ช่วยให้เกิดการซื้อขายได้อย่างรวดเร็ว</span>
					</p>
				</div>
			</div>
		</div>

		<!--  -->
		<div class="support">
			<div
				class="d-flex flex-column flex-md-row justify-center mx-auto my-6 my-md-12 pa-4"
				classs="d-flex justify-center mx-auto my-6 my-md-12 pa-4"
				style="max-width: 1700px;"
			>
				<div
					class="text-center align-self-center align-self-md-auto d-md-flex mr-xl-12"
					classs="d-none d-md-flex mr-xl-12"
					:style="{'width': supportImageWidth, 'max-width': '100%'}"
				>
					<img
						ref="supportImageFloat"
						src="/images/2.0/service/Support-00.png"
						class="support-image mx-auto mb-6 mb-md-0"
						:class="{'support-image-float' : supportImageFloat, 'mt-auto': supportImageStayBot}"
					>
				</div>
				<div
					ref="supportList"
					class="support-list ml-lg-12 pl-md-3 pl-lg-12"
				>
					<p class="head">
						สิ่งที่ THE BEST PROPERTY ช่วยคุณได้<br>
						<span>
							THE BEST <b class="red--text">SUPPORTS</b>
						</span>
					</p>
					<div class="d-flex">
						<div>
							<img
								src="/images/2.0/service/ICON00-01.png"
								style="width: clamp(50px, 10vw, 150px);"
							>
						</div>
						<div class="pl-md-2 pl-xl-12">
							<ul>
								<li>
									<p style="height: clamp(80px, 15vw, 220px);">
										<b>ประเมินราคาขายที่เหมาะสม</b><br>
										วิเคราะห์ข้อมูลจากราคาตลาด และฐานข้อมูล Big Data<br>
										ของบริษัท วิเคราะห์คู่แข่งและตั้งราคาขายที่เหมาะสม
									</p>
								</li>
								<li>
									<p style="height: clamp(80px, 18vw, 275px);">
										<b>ทําการตลาดครบทุกช่องทาง</b><br>
										การตลาด Online Marketing ลงประกาศขายในเว็บไซต์<br>
										ต่างๆ ระดับประเทศ และ ติดอันดับ การค้นหาใน Google<br>
										พร้อมทั้ง Offline Marketing ผลิตและติดตั้งป้ายโฆษณา
									</p>
								</li>
								<li>
									<p style="height: clamp(80px, 15.8vw, 240px);">
										<b>ตัวแทนมืออาชีพพร้อมดูแลการขาย</b><br>
										Agent Marketing ตัวแทนช่วยกันขายมากกว่า 1,000 คน<br>
										พร้อมนําเสนอปิดดีลการขายอย่างมืออาชีพ
									</p>
								</li>
								<li>
									<p style="height: clamp(80px, 16vw, 240px);">
										<b>ดูแลเอกสารสัญญาต่างๆ ในการซื้อ-ขาย</b><br>
										ฝ่ายกฎหมายและเอกสารสัญญา ที่ใช้ในการซื้อขายอสังหาฯ<br>
										ดูแลผลประโยชน์ให้กับผู้จะขายและผู้จะซื้ออย่างเป็นธรรม
									</p>
								</li>
								<li>
									<p style="height: clamp(80px, 15.5vw, 234px);">
										<b>บริการจัดสินเชื่อ</b><br>
										ฝ่ายสินเชื่อ ที่คอยดูแลเรื่องการยื่นกู้ พร้อมดีลกับธนาคาร<br>
										ประสานงานให้ตั้งแต่ต้นจนจบ
									</p>
								</li>
								<li>
									<p>
										<b>ดูแลการโอนให้จบครบทุกขั้นตอน</b><br>
										ช่วยเตรียมความพร้อมก่อนโอนกรรมสิทธิ์ เรื่อง<br>
										เอกสารต่างๆ และค่าใช้จ่ายในการโอนฯ อํานวยความสะดวก<br>
										ทุกขั้นตอนที่สํานักงานที่ดิน
									</p>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<v-row
				no-gutters
				class="d-none d-md-flex"
			>
				<v-col cols="3">
					<v-img
						src="/images/2.0/service/Support-02.jpg"
						width="100%"
						height="100%"
						class="overlay"
					/>
				</v-col>
				<v-col cols="3">
					<div class="bg-red fill-height text-center d-flex flex-column justify-center">
						<b style="font-size: clamp(22px, 4.5vw, 100px); line-height: clamp(22px, 4.5vw, 100px);">
							THE<br>
							BEST
						</b>
						<b style="font-size: clamp(22px, 3.5vw, 86px); line-height: clamp(22px, 3.5vw, 86px); color: #fff;">
							SUPPORT
						</b>
						<span style="font-size: clamp(22px, 3.5vw, 86px); line-height: clamp(22px, 3.5vw, 86px);">
							TEAM<br>
							/
						</span>

						<span style="font-size: clamp(7px, 1.2vw, 26px); line-height: clamp(7px, 1.2vw, 26px); color: #fff;">
							เราพร้อมจะดูแลในทุก ๆ ช่องทาง<br>
							ไม่ว่าจะเป็นในเรื่องของ การตลาด<br>
							สินเชื่อ และกฏหมาย ตั้งแต่ต้น<br>
							จนจบด้วยทีมงานมืออาชีพ
						</span>
					</div>
				</v-col>
				<v-col cols="3">
					<v-img
						src="/images/2.0/service/Support-03.jpg"
						width="100%"
						height="100%"
					/>
				</v-col>
				<v-col cols="3">
					<v-img
						src="/images/2.0/service/Support-04.jpg"
						width="100%"
						height="100%"
						class="overlay"
					/>
				</v-col>
			</v-row>
		</div>

		<!--  -->
		<div class="success-story">
			<div class="py-6 py-sm-12">
				<div style="width: 90%; margin: 0 auto; padding-left: 4%;">
					<p style="font-size: clamp(26px, 10.4vw, 200px); line-height: clamp(26px, 11vw, 210px);">
						<b class="red--text">Success</b>Story
					</p>
					<p style="font-size: clamp(10px, 3vw, 58px); line-height: clamp(10px, 3vw, 60px);">
						สิ่งที่เราภูมิใจมากที่สุด คือได้เห็นรอยยิ้มของตัวแทน<br>
						และลูกค้าของเราทุกคน จากความสุขที่เราได้ส่งมอบ
					</p>
				</div>

				<div class="ss01" />
				<div class="ss02" />
				<div class="ss03" />
				<div class="ss04" />
				<div class="ss05" />
			</div>

			<v-parallax
				v-intersect="{
					handler: onIntersectSuccessStory,
					options: {
						threshold: [1.0]
					}
				}"
				height="1"
			/>

			<v-img
				src="/images/2.0/service/SuccessStory-06_new.jpg"
				width="100%"
				max-width="1920"
				:class="{'fade-in-active': ssImgShow}"
				class="fade-in"
			/>
			<v-row
				no-gutters
				class="mb-4 mb-sm-0"
			>
				<v-col
					cols="12"
					sm="8"
					md="7"
					class="text-center text-sm-right py-4 py-sm-8"
				>
					<p style="font-size: clamp(10px, 4vw, 64px); line-height: clamp(10px, 4vw, 64px); margin: 0;">
						ได้ส่งมอบอสังหาฯ ให้กับผู้จะซื้อ<br>
						<b style="font-size: clamp(10px, 5.5vw, 64px); line-height: clamp(10px, 6vw, 64px);">
							มากกว่า
							<span class="red--text">10,000</span>
							รายการ
						</b>
					</p>
				</v-col>
				<v-col
					cols="12"
					sm="4"
					md="5"
					class="d-flex justify-center align-center"
				>
					<v-btn
						rounded
						color="rgb(237,28,36)"
						colors="#ff0000"
						min-width="94"
						min-height="30"
						width="9vw"
						height="2.5vw"
						style="font-size: max(1vw, 12px); font-weight: bold;"
						dark
						:to="{name: 'portfolio'}"
					>
						ดูเพิ่มเติม
					</v-btn>
				</v-col>
			</v-row>
		</div>

		<!--  -->
		<div class="property-sale">
			<v-row class="pa-sm-4">
				<v-col
					cols="12"
					sm="4"
					class="d-flex flex-column"
				>
					<v-img
						src="/images/2.0/service/The-Best-Property-01.jpg"
						class="flex-grow-1"
					/>
					<div class="d-none d-sm-block">
						<p style="font-size: clamp(10px, 9vw, 168px); line-height: clamp(10px, 7vw, 128px); font-weight: bold;">
							BE<br>
							<span class="red--text">HAPPY</span>
						</p>
						<p style="font-size: clamp(10px, 2.9vw, 54px); line-height: clamp(10px, 3vw, 54px);">
							ส่งต่อที่อยู่ของความสุข
						</p>
					</div>
				</v-col>
				<v-col
					cols="12"
					sm="4"
					class="d-none d-sm-flex flex-column justify-end pt-8"
				>
					<v-img
						src="/images/2.0/service/The-Best-Property-02.jpg"
						class="flex-grow-1"
					/>
				</v-col>
				<v-col
					cols="12"
					sm="4"
					class="d-flex flex-column justify-sm-end pt-sm-12"
				>
					<p
						class="d-none d-sm-block flex-grow-0"
						style="font-size: clamp(10px, 2.5vw, 50px); line-height: clamp(10px, 2.7vw, 55px); text-align: center;"
					>
						ส่งต่อที่อยู่ของความสุข<br>
						ค้นหา
						<b class="red--text">"บ้าน"</b>
						ที่ใช่สําหรับคุณ
					</p>
					<div class="float-text flex-grow-0">
						<p>ตอบโจทย์ทุกไลฟ์สไตล์</p>
						<p>บ้านเดี่ยว บ้านแฝด ทาวน์โฮม คอนโด</p>
					</div>
					<v-img
						src="/images/2.0/service/The-Best-Property-03.jpg"
						class="flex-grow-0 flex-shrink-1"
					/>
				</v-col>
			</v-row>

			<v-row>
				<v-col
					cols="12"
					class="bg-red pa-4 d-sm-none"
				>
					<div style="transform: scale(0.9);">
						<b style="font-size: clamp(10px, 8.5vw, 48px); line-height: clamp(10px, 8.5vw, 48px);">
							<span class="white--text">THE BEST</span> PROPERTY
						</b>
						<p style="font-size: clamp(10px, 4.6vw, 26px); line-height: clamp(10px, 4.6vw, 26px); color: #fff;">
							เรารวบรวมอสังหาฯ คุณภาพกว่า
						</p>
						<span style="font-size: clamp(10px, 3.7vw, 70px); color: #fff;">
							<b style="font-size: clamp(10px, 23vw, 140px); line-height: clamp(10px, 16vw, 90px);">20,000</b>
							รายการ
						</span>
					</div>
				</v-col>
				<v-col
					cols="12"
					sm="8"
					class="bg-red d-none d-sm-block pa-4 pa-md-6 pa-lg-10"
				>
					<b style="font-size: clamp(10px, 4.5vw, 90px); line-height: clamp(10px, 4.5vw, 90px);">
						<span class="white--text">THE BEST</span> PROPERTY
					</b>
					<p style="font-size: clamp(10px, 2.6vw, 50px); line-height: clamp(10px, 2.6vw, 52px); color: #fff;">
						เรารวบรวมอสังหาฯ คุณภาพกว่า
					</p>
					<span style="font-size: clamp(10px, 3.5vw, 70px); color: #fff;">
						<b style="font-size: clamp(10px, 14vw, 268px); line-height: clamp(10px, 10vw, 180px);">20,000</b>
						รายการ
					</span>
				</v-col>
				<v-col cols="4" class="pa-1 d-none d-sm-block">
					<v-row no-gutters class="table-img">
						<v-col cols="4" class="pa-1">
							<v-img src="/images/2.0/service/The-Best-Property-04.jpg" class="fill-height" />
						</v-col>
						<v-col cols="4" class="pa-1">
							<v-img src="/images/2.0/service/The-Best-Property-05.jpg" class="fill-height" />
						</v-col>
						<v-col cols="4" class="pa-1">
							<v-img src="/images/2.0/service/The-Best-Property-06.jpg" class="fill-height" />
						</v-col>
						<v-col cols="4" class="pa-1">
							<v-img src="/images/2.0/service/The-Best-Property-07.jpg" class="fill-height" />
						</v-col>
						<v-col cols="4" class="pa-1">
							<v-img src="/images/2.0/service/The-Best-Property-08.jpg" class="fill-height" />
						</v-col>
						<v-col cols="4" class="pa-1">
							<v-img src="/images/2.0/service/The-Best-Property-09.jpg" class="fill-height" />
						</v-col>
						<v-col cols="4" class="pa-1">
							<v-img src="/images/2.0/service/The-Best-Property-10.jpg" class="fill-height" />
						</v-col>
						<v-col cols="4" class="pa-1">
							<v-img src="/images/2.0/service/The-Best-Property-11.jpg" class="fill-height" />
						</v-col>
						<v-col cols="4" class="pa-1">
							<v-img src="/images/2.0/service/The-Best-Property-12.jpg" class="fill-height" />
						</v-col>
					</v-row>
				</v-col>
			</v-row>

			<div class="d-sm-none pa-4 pa-md-6 pa-lg-10">
				<p style="font-size: clamp(10px, 4.5vw, 27px); line-height: clamp(10px, 5vw, 30px); text-align: center;">
					<b
						class=""
						style="font-size: clamp(10px, 6.8vw, 40px); line-height: clamp(10px, 7vw, 44px);"
					>
						ทําไมต้อง <span class="red--text">THE BEST PROPERTY</span>
					</b><br>
					ได้บ้านคุณภาพง่ายๆ ดูแลคุณอย่างมืออาชีพ
				</p>

				<div class="why-tb-list mobile">
					<b>01</b>
					<p>
						<b>อสังหาฯ คุณภาพกว่า 20,000 รายการ</b><br>
						ราคาที่เหมาะสม ตอบโจทย์ทุกความต้องการ
					</p>
				</div>
				<div class="why-tb-list mobile">
					<b>02</b>
					<p>
						<b>ฝ่ายสินเชื่อ ประสานงานให้ตั้งแต่ต้นจนจบ</b> ดูแลเรื่อง<br>
						การยื่นกู้ ช่วยวิเคราะห์ เลือกธนาคารที่เหมาะสม
					</p>
				</div>
				<div class="why-tb-list mobile">
					<b>03</b>
					<p>
						<b>ดูแลการขายให้คุณอย่างมืออาชีพ</b> อํานวยความสะดวก<br>
						ทุกขั้นตอนที่สํานักงานที่ดิน
					</p>
				</div>
			</div>
			<div class="why-tb d-none d-sm-block pa-4 pa-md-6 pa-lg-10">
				<div style="transform: scale(0.9);">
					<p style="font-size: clamp(10px, 3vw, 56px); line-height: clamp(10px, 3.5vw, 60px); margin-left: min(6vw, 120px); text-align: center; display: inline-block;">
						<b
							class=""
							style="font-size: clamp(10px, 4.5vw, 84px); line-height: clamp(10px, 5vw, 94px);"
						>
							ทําไมต้อง <span class="red--text">THE BEST PROPERTY</span>
						</b><br>
						ได้บ้านคุณภาพง่ายๆ ดูแลคุณอย่างมืออาชีพ
					</p>

					<div class="why-tb-list">
						<b>01</b>
						<p>
							<b>อสังหาฯ คุณภาพกว่า 20,000 รายการ</b><br>
							ราคาที่เหมาะสม ตอบโจทย์ทุกความต้องการ
						</p>
					</div>
					<div class="why-tb-list">
						<b>02</b>
						<p>
							<b>ฝ่ายสินเชื่อ ประสานงานให้ตั้งแต่ต้นจนจบ</b> ดูแลเรื่อง<br>
							การยื่นกู้ ช่วยวิเคราะห์ เลือกธนาคารที่เหมาะสม
						</p>
					</div>
					<div class="why-tb-list">
						<b>03</b>
						<p>
							<b>ดูแลการขายให้คุณอย่างมืออาชีพ</b> อํานวยความสะดวก<br>
							ทุกขั้นตอนที่สํานักงานที่ดิน
						</p>
					</div>
				</div>
			</div>
			<div class="why-tb-cont pa-9 pa-md-6 pa-lg-10">
				<p
					class="d-inline-block d-sm-block"
					style="font-size: clamp(10px, 4.5vw, 26px); line-height: clamp(10px, 6.5vw, 38px); margin: 0; text-align: center;"
				>
					<b>
						เรามุ่งมั่นที่จะรวบรวมที่อยู่อาศัย<br class="d-md-none"> ตอบโจทย์ทุกไลฟ์สไตล์
					</b><br>
					บ้าน...ที่ใช่ในทุกความรู้สึก<br class="d-md-none"> เพราะสิ่งที่สวยงามที่สุดของ<br class="d-md-none">บ้านคือ “ความสุข” ของคนในครอบครัว
				</p>
			</div>

			<div
				ref="videoRef"
				class="mx-auto mb-n2"
				style="width: 100%;"
			/>
		</div>

		<!--  -->
		<div class="agent">
			<v-row
				no-gutters
				class="be-agent"
			>
				<v-col
					cols="6"
					class="pl-3 pl-sm-6 pl-md-12 py-3 py-sm-6 py-md-12 d-flex flex-column justify-space-around"
				>
					<b>
						การเดินทางสู่ความสําเร็จ<br>ในวงการนายหน้าอสังหาฯ
					</b>
					<p>
						ศูนย์รวมอสังหาฯ บ้านมือสอง คุณภาพอันดับ 1<br>
						ทุกทําเล ทุกราคา สําหรับนายหน้าอสังหาฯ<br>
						Agent Networking มากกว่า 1,000 คน
					</p>
					<div class="d-flex justify-center ml-n3 ml-sm-n6 ml-md-n12">
						<v-btn
							color="rgb(237,28,36)"
							width="clamp(74px, 11vw, 220px)"
							height="clamp(20px, 2.5vw, 54px)"
							style="font-size: clamp(8px, 1vw, 22px); font-weight: bold; border-radius: 14px;"
							dark
							:to="{name: 'guest-register', query: {'ref': '1002'}}"
						>
							สมัครเป็นตัวแทน
						</v-btn>

						<v-btn
							color="#fff"
							width="clamp(74px, 11vw, 220px)"
							height="clamp(20px, 2.5vw, 54px)"
							class="ml-2 ml-sm-6 ml-md-12"
							style="font-size: clamp(8px, 1vw, 22px); font-weight: bold; color: rgb(237,28,36); border-radius: 14px;"
							:to="{name: 'contact-us'}"
						>
							สอบถามเพิ่มเติม
						</v-btn>
					</div>
				</v-col>
			</v-row>

			<div class="chance bg-red py-4 py-md-6 py-lg-8 px-3 px-md-6 px-lg-12 d-flex justify-center">
				<div class="d-flex align-end">
					<span class="white--text">
						โครงการที่มีโอกาสดูแล
						<b>การขายมากกว่า</b>
					</span>
					<b class="white--text">30,000</b>
					<span>รายการ</span>
				</div>
				<!-- <v-divider
					class="mx-2 mx-md-4 d-block"
					vertical
				/> -->
				<div class="d-flex align-end">
					<v-divider
						class="mx-2 mx-md-4"
						vertical
					/>
					<span class="white--text">
						ส่งมอบโอกาสให้กับ
						<b>ตัวแทนมากกว่า</b>
					</span>
					<b class="white--text">5,000</b>
					<span>คน</span>
				</div>
			</div>

			<v-row
				no-gutters
				class="first-step"
			>
				<v-col
					cols="6"
					offset="6"
					class="pl-3 pl-sm-6 pl-md-12 py-3 py-sm-6 py-md-12 d-flex flex-column justify-space-around"
				>
					<p style="margin: 0 0 0 clamp(-140px, -7vw, 0px); font-size: clamp(10px, 2.45vw, 50px); line-height: clamp(10px, 3vw, 62px);">
						<b style="font-size: clamp(10px, 3.4vw, 68px); line-height: clamp(10px, 3.8vw, 76px);">
							THE BEST PROPERTY <span class="red--text">AGENT</span>
						</b><br>
						พร้อมอัปเกรดคุณเป็นนายหน้ามืออาชีพ<br>
						มีทรัพย์ให้ขายทันที มากกว่า <b class="red--text">20,000</b> รายการ
					</p>
					<b style="margin: 0 0 0 clamp(-80px, -4vw, 0px); font-size: clamp(10px, 2.8vw, 50px); line-height: clamp(10px, 3.1vw, 60px);">
						<span class="red--text">“ก้าวแรก”</span> ของการเป็นนายหน้าอสังหาฯ<br>
						จากจุดเริ่มต้นสู่การเป็นนายหน้ามืออาชีพ
					</b>
					<p style="margin: 0; font-size: clamp(8px, 1.85vw, 30px); line-height: clamp(10px, 2vw, 32px);">
						<b
							style="font-size: clamp(10px, 2.9vw, 53px); line-height: clamp(10px, 3.4vw, 62px);"
							class="red--text"
						>
							คอร์ส STARTUP AGENT SEMINAR
						</b><br>
						เจาะลึก 1 วันเต็มทําอย่างไรถึงจะเป็นนายหน้ามืออาชีพ?
					</p>
				</v-col>
			</v-row>

			<v-img
				src="/images/2.0/service/Agent-03.jpg"
				width="100%"
				max-width="1920"
			/>

			<p style="font-size: clamp(9px, 2.4vw, 46px); line-height: clamp(10px, 2.7vw, 60px); text-align: center">
				พร้อมนําคุณเข้าสู่ ธุรกิจนายหน้าอสังหาฯ อย่างเต็มตัว<br>
				<b
					class="red--text"
					style="font-size: clamp(10px, 3.2vw, 64px); line-height: clamp(10px, 4.5vw, 90px);"
				>
					ยกระดับประสบการณ์การทํางาน เพิ่มความเป็นมือโปร..ให้กับคุณ
				</b><br>
				<b>หลักสูตร STARTUP AGENT SEMINAR</b> คอร์สสําหรับ เริ่มต้นอาชีพนายหน้าอสังหาฯ ไม่มีความรู้<br>
				เรื่องนายหน้ามาก่อนก็สามารถเรียนได้ ให้ความรู้แนะนําวิธีการจนถึงบอกเคล็ดลับการเริ่มต้นอาชีพ<br>
				นายหน้า สู่การเป็นนายหน้ามืออาชีพ พร้อมการใช้ระบบ SMART AGENT SYSTEM เครื่องมือที่<br>
				จะช่วยให้การทํางานของคุณสะดวก รวดเร็วมากยิ่งขึ้น
			</p>

			<v-parallax
				src="/images/2.0/service/Agent-04_0.jpg"
				class="mt-md-12"
				style="max-height: min(44.65vw, 912px); overflow: unset;"
				height="912"
				dark
			>
				<v-row>
					<v-col
						cols="12"
						sm="7"
						class="pa-3 py-sm-9 pl-sm-6"
					>
						<div
							class="ml-lg-12 py-lg-9 d-flex flex-column justify-space-around fill-height"
							style="width: fit-content;"
						>
							<div class="benefit">
								<b>3</b>
								<p>
									<b class="red--text">START UP AGENT SEMINAR</b><br>
									<b>สิทธิประโยชน์ ที่คุณจะได้รับ</b>
								</p>
							</div>
							<div class="benefit">
								<b><img src="/images/2.0/service/Agent-04_2.png"></b>
								<p>
									ได้เข้าเรียนหลักสูตร <b class="red--text">3 Find 4 Sell</b><br>
									คอร์ส EXCLUSIVE สู่นายหน้ามืออาชีพ (e-Learning)
								</p>
							</div>
							<div class="benefit">
								<b><img src="/images/2.0/service/Agent-04_2.png"></b>
								<p>
									รับ ฟรี! <b class="red--text">ชุด STARTER KIT</b>
									พร้อมเริ่มงานได้ทันที
								</p>
							</div>
							<div class="benefit">
								<b><img src="/images/2.0/service/Agent-04_2.png"></b>
								<p>
									ได้เงินค่าคอร์ส<b class="red--text">คืนเต็มจํานวน (Refund)</b><br>
									พร้อมโบนัส รวมเป็นเงิน <b class="red--text">5,000.-</b>
									<span>เงื่อนไขเป็นไปตามที่บริษัทฯ กําหนด รายละเอียดเพิ่มเติมใน Instant Intro</span>
								</p>
							</div>

							<div class="d-none d-sm-flex justify-center mt-sm-3 mt-lg-8">
								<v-btn
									color="rgb(237,28,36)"
									width="clamp(120px, 13vw, 260px)"
									height="clamp(20px, 2.5vw, 54px)"
									style="font-size: clamp(8px, 1vw, 22px); font-weight: bold; border-radius: 14px;"
									dark
									:to="{name: 'guest-register', query: {'ref': '1002'}}"
								>
									ลงทะเบียนสมัครคอร์ส
								</v-btn>

								<v-btn
									color="#fff"
									width="clamp(74px, 11vw, 220px)"
									height="clamp(20px, 2.5vw, 54px)"
									class="ml-2 ml-sm-6 ml-md-12"
									style="font-size: clamp(8px, 1vw, 22px); font-weight: bold; color: rgb(237,28,36); border-radius: 14px;"
									:to="{name: 'contact-us'}"
								>
									สอบถามเพิ่มเติม
								</v-btn>
							</div>
						</div>
					</v-col>
					<v-col
						cols="5"
						class="d-none d-sm-block text-right"
					>
						<img
							src="/images/2.0/service/Agent-04_1.png"
							style="margin-top: clamp(-38px, -1.45vw, 0px); width: clamp(100px, 37.5vw, 769px);"
						>
					</v-col>
				</v-row>
			</v-parallax>

			<div class="go-together d-flex justify-center align-center">
				<img src="/images/2.0/service/Agent-05.png">
				<p>
					ก้าวแรกอย่างมั่นใจในการเป็นนายหน้าอสังหาฯ<br>
					<b>ก้าวไปพร้อมกับเรา THE BEST PROPERTY <span class="red--text">AGENT</span></b>
				</p>
			</div>

			<div class="experience">
				<p class="ma-0">
					<b>เปิดประสบการณ์ใหม่</b><br> ที่ทําให้คุณได้มากกว่าคําว่า “นายหน้าอสังหาฯ”
				</p>
				<!-- <p class="d-md-none mb-0">
					เราคือผู้นําด้านธุรกิจนายหน้า<br>ตัวแทนอสังหาริมทรัพย์ครบวงจร
				</p> -->

				<v-row class="mt-sm-4">
					<v-col
						cols="12"
						sm="6"
						md="4"
					>
						<v-row no-gutters>
							<v-col
								cols="6"
								sm="12"
							>
								<p>
									<b>ประสบการณ์มากกว่า 10 ปี<br>ในวงการอสังหาริมทรัพย์</b>
								</p>
								<p>THE BEST PROPERTY AGENT เรามีความพร้อมทั้ง<br class="d-none d-sm-block"> ประสบการณ์ เทคโนโลยีและนวัตกรรมที่สร้างสรรค์<br class="d-none d-sm-block"> ตอบโจทย์การทํางานของนายหน้ายุคใหม่</p>
							</v-col>
							<v-col
								cols="6"
								sm="12"
							>
								<v-img
									src="/images/2.0/service/Agent-08.png"
									width="100%"
								/>
							</v-col>
						</v-row>
					</v-col>

					<v-col
						cols="12"
						sm="6"
						md="4"
					>
						<v-row
							no-gutters
							class="flex-row-reverse"
						>
							<v-col
								cols="6"
								sm="12"
							>
								<p>
									<b>SMART AGENT SYSTEM<br>เพิ่มความเป็นมือโปร..ให้กับคุณ</b>
								</p>
								<p>เครื่องมือที่จะช่วยให้การทํางานของคุณสะดวก รวดเร็ว<br class="d-none d-sm-block"> มากยิ่งขึ้น ยกระดับประสบการณ์การทํางานในรูปแบบใหม่<br class="d-none d-sm-block"> สนับสนุนการทํางานในทุก ๆ มิติ</p>
							</v-col>
							<v-col
								cols="6"
								sm="12"
							>
								<v-img
									src="/images/2.0/service/Agent-09.png"
									width="100%"
								/>
							</v-col>
						</v-row>
					</v-col>

					<v-col
						cols="12"
						sm="6"
						md="4"
					>
						<v-row no-gutters>
							<v-col
								cols="6"
								sm="12"
							>
								<p>
									<b>ทําได้แม้ไม่มีประสบการณ์<br>มีระบบการเรียนรู้ e-Learning</b>
								</p>
								<p>ยกระดับความรู้สําหรับนายหน้ามืออาชีพ ตั้งแต่ 0-100<br class="d-none d-sm-block"> ด้วย e-Learning หลักสูตร Exclusive สอนคุณจากนาย<br class="d-none d-sm-block"> หน้ามือใหม่สู่มืออาชีพ ที่ไม่มี..ที่ไหนกล้าบอกคุณ!!</p>
							</v-col>
							<v-col
								cols="6"
								sm="12"
							>
								<v-img
									src="/images/2.0/service/Agent-10.png"
									width="100%"
								/>
							</v-col>
						</v-row>
					</v-col>

					<v-col
						cols="12"
						sm="6"
						md="4"
					>
						<v-row
							no-gutters
							class="flex-row-reverse"
						>
							<v-col
								cols="6"
								sm="12"
							>
								<p>
									<b>มีงานประจําก็ทําได้<br>อิสระในเรื่องของเวลา 100%</b>
								</p>
								<p>สําหรับผู้ที่มีงานประจํา หรืออาชีพหลักอยู่แล้ว แต่ต้องการ<br class="d-none d-sm-block"> หารายได้เสริม เพิ่มช่องทางรายได้ พร้อมทั้งอิสระด้านเวลา<br class="d-none d-sm-block"> THE BEST PROPERTY AGENT คือที่สําหรับคุณ</p>
							</v-col>
							<v-col
								cols="6"
								sm="12"
							>
								<v-img
									src="/images/2.0/service/Agent-11.png"
									width="100%"
								/>
							</v-col>
						</v-row>
					</v-col>

					<v-col
						cols="12"
						sm="6"
						md="4"
					>
						<v-row no-gutters>
							<v-col
								cols="6"
								sm="12"
							>
								<p>
									<b>มีทรัพย์ให้ขายทันที มากกว่า<br>20,000 รายการ</b>
								</p>
								<p>
									ให้คุณพร้อมเริ่มต้นสําหรับเป็นนายหน้าอสังหาฯ ได้ทันที<br class="d-none d-sm-block">
									THE BEST PROPERTY AGENT เรามีอสังหาฯ มือสอง<br class="d-none d-sm-block">
									ฝากขาย อาทิ บ้านเดี่ยว ทาวน์โฮม คอนโด ที่ดิน และอื่นๆ
								</p>
							</v-col>
							<v-col
								cols="6"
								sm="12"
							>
								<v-img
									src="/images/2.0/service/Agent-12.png"
									width="100%"
								/>
							</v-col>
						</v-row>
					</v-col>

					<v-col
						cols="12"
						sm="6"
						md="4"
					>
						<v-row
							no-gutters
							class="flex-row-reverse"
						>
							<v-col
								cols="6"
								sm="12"
							>
								<p>
									<b>ภาพลักษณ์ ของนายหน้า<br>อสังหาฯ เป็นเรื่องสําคัญ</b>
								</p>
								<p>
									THE BEST PROPERTY AGENT เรามีให้ทั้ง สัญญา<br class="d-none d-sm-block">
									นามบัตร ป้ายไวนิล ฟิวเจอร์บอร์ด ให้คุณโดยไม่ต้อง<br class="d-none d-sm-block">
									ลงทุนเอง เริ่มต้นทํางานได้ทันที
								</p>
							</v-col>
							<v-col
								cols="6"
								sm="12"
							>
								<v-img
									src="/images/2.0/service/Agent-13.png"
									width="100%"
								/>
							</v-col>
						</v-row>
					</v-col>

					<v-col
						cols="12"
						sm="6"
						md="4"
					>
						<v-row no-gutters>
							<v-col
								cols="6"
								sm="12"
							>
								<p>
									<b>The Best Marketing<br>คนเห็นมาก โอกาสขายก็มาก</b>
								</p>
								<p>
									การตลาดออนไลน์ ครอบคลุมทุกแพลตฟอร์มชั้นนํา<br class="d-none d-sm-block">
									เข้าถึงผู้ที่ต้องการซื่อมากกว่า 30 ล้าน ยอดชมต่อเดือน<br class="d-none d-sm-block">
									พร้อมยังมีตัวแทนช่วยกันขายมากกว่า 1,000 คน
								</p>
							</v-col>
							<v-col
								cols="6"
								sm="12"
							>
								<v-img
									src="/images/2.0/service/Agent-14.png"
									width="100%"
								/>
							</v-col>
						</v-row>
					</v-col>

					<v-col
						cols="12"
						sm="6"
						md="4"
					>
						<v-row
							no-gutters
							class="flex-row-reverse"
						>
							<v-col
								cols="6"
								sm="12"
							>
								<p>
									<b>พร้อมให้คําปรึกษา ทีมสินเชื่อ<br>และทีมกฎหมาย มืออาชีพ</b>
								</p>
								<p>
									ทีมสินเชื่อมืออาชีพ พร้อมดีลทุกธนาคาร อํานวยความ<br class="d-none d-sm-block">
									สะดวกให้ตัวแทนทุกขั้นตอน อีกทั้งทีมกฎหมาย พร้อม<br class="d-none d-sm-block">
									ดูแลเอกสารสัญญา เพื่อสนับสนุนตัวแทนทุกคน
								</p>
							</v-col>
							<v-col
								cols="6"
								sm="12"
							>
								<v-img
									src="/images/2.0/service/Agent-15.png"
									width="100%"
								/>
							</v-col>
						</v-row>
					</v-col>

					<v-col
						cols="12"
						md="4"
						class="d-flex flex-column justify-center"
					>
						<div>
							<v-img
								src="/images/2.0/LOGO.TB.CO.TH.png"
								width="50%"
								class="d-none d-md-block"
							/>
						</div>
						<p class="mt-4 d-none d-md-block">
							เราคือผู้นําด้านธุรกิจนายหน้า<br>
							ตัวแทนอสังหาริมทรัพย์ครบวงจร
						</p>
						<p class="text-center text-md-left">
							<b class="d-md-none">เราคือผู้นําด้านธุรกิจนายหน้าตัวแทนอสังหาฯ<br></b>
							เพื่อส่งมอบสิ่งที่ดีที่สุดให้กับ<br class="d-none d-md-block">
							ลูกค้า ด้วยความเป็นมืออาชีพ
						</p>
					</v-col>
				</v-row>
			</div>

			<div class="text-center py-6">
				<b style="font-size: clamp(10px, 4.4vw, 84px); line-height: clamp(10px, 5vw, 115px);">
					<span class="red--text">THE BEST</span> PROPERTY AGENT
				</b>
				<!-- <hr style="width: 20%; margin: 0 auto; border: solid 1px #000;"> -->
				<p style="font-size: clamp(10px, 2.9vw, 66px); line-height: clamp(10px, 3.5vw, 80px); margin: 0;">
					ไม่ว่าสิ่งที่ดีที่สุดของคุณคืออะไร<br>
					<span
						class="red--text"
						style="font-size: clamp(10px, 3.3vw, 76px); line-height: clamp(10px, 4.7vw, 96px);"
					>
						"เราจะมอบ<b>สิ่งที่ดีที่สุด</b>ให้คุณเสมอ"
					</span>
				</p>
			</div>

			<v-img
				src="/images/2.0/service/Agent-16.jpg"
				width="100%"
			/>
		</div>
	</v-main>
</template>

<script>

const doc = 'index'

import { mapGetters, mapMutations } from 'vuex'

export default {
	// scrollToTop: true,
	name: 'SERVICE',
	layout: 'default_2',

	components: {

	},

	async fetch(context) {
		await context.store.dispatch('page/initial', {
			doc: doc,
			fullPath: context.route.fullPath
		})
		await context.store.dispatch('setShowFooter')
	},

	data() {
		return {
			awardImgShow: false,
			ssImgShow: false,
			supportImageFloat: false,
			supportImageStayBot: false,
			supportImageWidth: 'auto',
			videoPlayer: null,
		}
	},

	computed: {
		...mapGetters({
			isMobile: 'isMobile',
			config: 'config',
			head: 'page/head' ,
		}),

		breakpoint () {
			return this.$vuetify.breakpoint.name
		},
	},

	watch: {

	},

	activated () {

	},
	deactivated () {

	},

	created() {

	},

	mounted() {
		this.setHead({
			doc: doc,
			href: window.location.href,
		})

		if (process.client) {
			this.$nextTick(() => {
				setTimeout(async () => {
					const elm = this.$refs.videoRef
					const Player = await import('@vimeo/player')
					this.videoPlayer = new Player.default(elm, {
						id: 1012671388,
						width: elm.offsetWidth,
						height: elm.offsetWidth * 0.5625,
						autoplay: true,
						// progress_bar: false,
						// controls: false,
						keyboard: false
					})
				})
			}, 100)
		}
	},

	methods: {
		...mapMutations({
			setHead: 'page/setHead'
		}),

		onIntersect (entries) {
			if (entries[0].intersectionRatio >= 0.5) {
				this.awardImgShow = true
			}
		},
		onIntersectSuccessStory (entries) {
			if (entries[0].intersectionRatio >= 1) {
				this.ssImgShow = true
			}
		},

		onScroll (e) {
			// if (e) return
			// if (this.videoPlayer && e.target.scrollingElement.scrollTop > this.$refs.videoRef.offsetTop) {
			// 	// console.log(this.videoPlayer)
			// 	if (e.target.click) {
			// 		e.target.click()
			// 	} else if (e.target.body.click) {
			// 		e.target.body.click()
			// 	}
			// 	this.videoPlayer.play()
			// }

			if (document.body.offsetWidth < 960) {
				return
			}

			this.supportImageWidth = this.$refs.supportImageFloat.width + 'px'
			if (e.target.scrollingElement.scrollTop > this.$refs.supportList.offsetTop &&
				e.target.scrollingElement.scrollTop < this.$refs.supportList.offsetTop + this.$refs.supportList.offsetHeight - this.$refs.supportImageFloat.offsetHeight
			) {
				this.supportImageFloat = true
			} else {
				this.supportImageFloat = false

				if (e.target.scrollingElement.scrollTop > this.$refs.supportList.offsetTop + this.$refs.supportList.offsetHeight - this.$refs.supportImageFloat.offsetHeight) {
					this.supportImageStayBot = true
				} else {
					this.supportImageStayBot = false
				}
			}
		},
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
.full-height {
	// height: calc(100vh - 64px);
	height: calc(100vh);

	& .d-sm-none {
		height: calc(100vh - 112px);
	}
}

.our-service {
	.row {
		img {
			display: block;
			margin: 8px auto;
		}
		b {
			font-size: 1.3rem;
		}
		p {
			margin: 0 auto;
			max-width: 270px;
		}
	}
}

.marketing-02 {
	background: url('/images/2.0/service/Marketing-02.png') no-repeat center;
	background-size: cover;
	height: 48.3vw !important;
	max-height: 927px;
}
.marketing-04 {
	background: url('/images/2.0/service/Marketing-04.png') no-repeat center;
	background-size: cover;
	height: 38.3vw !important;
	max-height: 735px;
}
.marketing-stuff {
	margin: 0 10px;
	font-size: clamp(14px, 1.6vw, 42px);
	line-height: clamp(14px, 2vw, 42px);
	padding: 0 0 10px 0;
	color: #f00;
	border-bottom: solid 1px #000;

	b {
		color: #000;
		display: block;
	}
}
.marketing-05 {
	background: url('/images/2.0/service/Marketing-05.png') no-repeat center;
	background-size: cover;
	height: 38.3vw !important;
	max-height: 735px;
}

.support {
	.support-image {
		max-width: 100%;
		max-height: calc(100vh - 120px);
		height: min-content;

		@media (min-width: 960px) {
			max-width: min(40vw, 510px);
			max-height: calc(100vh - 70px);
		}

		&.support-image-float {
			position: fixed;
			top: 64px;
			z-index: 6;
		}
	}

	.support-list {
		@media (min-width: 600px) {
			transform: scale(0.9);
		}

		.head {
			font-size: clamp(10px, 3.2vw, 62px);
			line-height: clamp(10px, 3.2vw, 62px);
			text-align: center;

			@media (max-width: 959px) {
				font-size: clamp(10px, 5vw, 48px);
				line-height: clamp(10px, 5vw, 48px);
			}

			span {
				font-size: clamp(10px, 5.8vw, 100px);
				line-height: clamp(10px, 6.2vw, 106px);

				@media (max-width: 959px) {
					font-size: clamp(10px, 9.8vw, 96px);
					line-height: clamp(10px, 10.5vw, 100px);
				}
			}
		}

		@media (max-width: 959px) {
			flex-grow: 1;

			img {
				width:clamp(50px, 14vw, 192px) !important;
			}
		}

		ul {
			list-style: none;

			@media (max-width: 599px) {
				padding-left: 8px;
			}

			& > li {
				@media (max-width: 959px) {
					&:nth-child(1) > p { height: clamp(80px, 21vw, 285px) !important; }
					&:nth-child(2) > p { height: clamp(80px, 25vw, 285px) !important; }
					&:nth-child(3) > p { height: clamp(80px, 22vw, 285px) !important; }
					&:nth-child(4) > p { height: clamp(80px, 23vw, 285px) !important; }
					&:nth-child(5) > p { height: clamp(80px, 22vw, 285px) !important; }
					&:nth-child(6) > p { height: clamp(80px, 23vw, 285px) !important; }
				}

				& > p {
					font-size: clamp(10px, 1.85vw, 32px);
					line-height: clamp(10px, 2.6vw, 46px);
					padding-top: clamp(30px, 3.2vw, 60px);
					margin: 0;

					@media (max-width: 959px) {
						font-size: clamp(12px, 3.2vw, 32px);
						line-height: clamp(10px, 3.6vw, 46px);
						padding-top: clamp(10px, 3.2vw, 60px);
					}

					b {
						color: rgb(237,28,36);
					}
				}
			}
		}
	}

	.row {
		& > div {
			position: relative;
			height: 30vw;

			&:not(:last-child) {
				padding-right: 1px;
			}
			&:not(:first-child) {
				padding-left: 1px;
			}

			.v-image.overlay::before {
				content: ' ';
				position: absolute;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.7);
			}
		}
	}
}

.success-story {
	margin: 0 auto;
	max-width: 1920px;

	& > div:first-child {
		background: url('/images/2.0/service/SuccessStory-07.png') no-repeat center;
		background-size: 100% 100%;
	}

	.ss01 {
		margin-top: max(-10vw, -172px);
		background: url('/images/2.0/service/SuccessStory-01.png') no-repeat center;
		background-size: cover;
		height: calc(39vw - 14px) !important;
		max-height: 715px;

		& > p {
			padding: 0 0 1vw 1vw;
			text-align: center;
			font-size: clamp(10px, 4.4vw, 52px);
			line-height: clamp(10px, 4.4vw, 52px);
		}
	}
	.ss02 {
		margin-top: max(-4.5vw, -115px);
		background: url('/images/2.0/service/SuccessStory-02.png') no-repeat center;
		background-size: cover;
		height: calc(33.1vw - 14px) !important;
		max-height: 596px;
	}
	.ss03 {
		margin-top: max(-4.5vw, -96px);
		background: url('/images/2.0/service/SuccessStory-03.png') no-repeat center;
		background-size: cover;
		height: calc(33.1vw - 14px) !important;
		max-height: 596px;
	}
	.ss04 {
		margin-top: max(-4vw, -105px);
		background: url('/images/2.0/service/SuccessStory-04.png') no-repeat center;
		background-size: cover;
		height: calc(35.3vw - 14px) !important;
		max-height: 630px;
	}
	.ss05 {
		margin-top: max(-2.5vw, -67px);
		background: url('/images/2.0/service/SuccessStory-05.png') no-repeat center;
		background-size: cover;
		height: calc(29.4vw - 10px) !important;
		max-height: 536px;
	}
}

.property-sale {
	& > div {
		margin: 0 auto;
		// max-width: 1860px;
		max-width: 1920px;

		&:first-child {
			background: url('/images/2.0/service/The-Best-Property-16.jpg') no-repeat center;
			background-size: 100% 100%;

			& > div:not(:last-child) {
				padding-bottom: 4vw;
			}
			& > div:last-child {
				max-height: 55vw;

				@media (max-width: 599px) {
					max-height: unset;
				}
			}

			img {
				width: 100%;
			}
		}
	}

	.table-img > div {
		height: clamp(55px, 8.5vw, 152px);
	}

	.float-text {
		text-align: center;
		font-size: clamp(10px, 1.8vw, 38px);
    line-height: clamp(10px, 2.2vw, 50px);
		width: 100%;

		@media (max-width: 599px) {
			position: absolute;
			z-index: 1;
			left: 0;
			margin-top: -8vw;
			font-size: 18px !important;

			& + .v-image {
				height: 100% !important;
			}
		}

		& > p:first-child {
			background: rgb(237,28,36);
			color: #fff;
			font-weight: bold;
			padding: min(3.7vw, 16px) 0;
		}
	}

	.why-tb {
		background: url('/images/2.0/service/The-Best-Property-13.jpg') no-repeat center;
		background-size: cover;
	}
	.why-tb-list {
		display: flex;
		align-items: center;

		& > b {
			width: clamp(50px, 13vw, 250px);
			text-align: center;
			color: rgb(237,28,36);
			font-size: clamp(10px, 9vw, 130px);
			line-height: clamp(10px, 10vw, 180px);
		}
		& > p {
			margin: 0;
			font-size: clamp(10px, 2.4vw, 40px);
			line-height: clamp(10px, 3.2vw, 54px);
		}

		&.mobile {
			& > b {
				width: clamp(50px, 16vw, 96px);
				text-align: center;
				color: rgb(237,28,36);
				font-size: clamp(10px, 12vw, 72px);
				line-height: clamp(10px, 12vw, 80px);
			}
			& > p {
				margin: 0;
				font-size: clamp(10px, 3.3vw, 20px);
				line-height: clamp(10px, 4.4vw, 26px);
			}
		}
	}
	.why-tb-cont {
		background: url('/images/2.0/service/The-Best-Property-14.jpg') no-repeat center;
		background-size: cover !important;

		@media (max-width: 599px) {
			background: url('/images/2.0/service/The-Best-Property-13.jpg') no-repeat center;
		}
	}
}

.agent {
	max-width: 1920px;
	margin: 0 auto;

	.be-agent {
		background: url('/images/2.0/service/Agent-01.jpg') no-repeat center;
		background-size: cover !important;
		height: clamp(150px, 40.7vw, 863px);

		b {
			font-size: clamp(10px, 4.4vw, 86px);
			line-height: clamp(10px, 4.8vw, 96px);
		}
		p {
			font-size: clamp(8px, 2.45vw, 48px);
			line-height: clamp(10px, 3vw, 58px);
		}
	}

	.chance {
		.v-divider {
			border: solid 1px #fff;
		}

		b {
			font-size: clamp(10px, 5.4vw, 126px);
			line-height: clamp(10px, 4.5vw, 94px);
			margin: 0 8px;
		}
		span {
			font-size: clamp(8px, 1.8vw, 40px);
			line-height: clamp(10px, 2.5vw, 50px);
			white-space: nowrap;

			b {
				margin: 0;
				display: block;
				font-size: clamp(10px, 2.7vw, 60px);
				line-height: clamp(10px, 2.3vw, 48px);
			}
		}
	}

	.first-step {
		background: url('/images/2.0/service/Agent-02.png') no-repeat center;
		background-size: cover !important;
		height: clamp(150px, 42.25vw, 811px);
		margin-top: clamp(-20px, -1.4vw, -8px);
	}

	.benefit {
		display: flex;
		align-items: center;

		& > b {
			width: clamp(50px, 6vw, 120px);
			color: rgb(237,28,36);
			font-size: clamp(10px, 10vw, 150px);
			line-height: clamp(10px, 9vw, 150px);
			justify-content: center;
			align-self: start;
			display: flex;
			flex-shrink: 0;

			img {
				width: clamp(10px, 4vw, 62px);
			}
		}
		& > p {
			margin: 0;
			font-size: clamp(10px, 2.5vw, 44px);
			line-height: clamp(10px, 2.8vw, 52px);
			white-space: nowrap;

			@media (max-width: 599px) {
				font-size: clamp(10px, 3.7vw, 44px);
				line-height: clamp(10px, 4vw, 52px);
			}

			b.red--text {
				font-size: clamp(10px, 3vw, 60px);
				line-height: clamp(10px, 3vw, 60px);
			}
			span {
				display: block;
				margin-top: 5px;
				font-size: clamp(10px, 1vw, 18px);
				line-height: clamp(10px, 1.2vw, 24px);
			}
		}
	}

	.go-together {
		padding: 1.5vw 0;
		background: url('/images/2.0/service/Agent-06.png') no-repeat center;
		background-size: cover !important;

		img {
			width: clamp(30px, 9vw, 180px);
			margin-right: 1.5vw;
		}
		p {
			margin: 0;
			text-align: center;
			font-size: clamp(10px, 3.6vw, 74px);
			line-height: clamp(10px, 4vw, 80px);
		}
	}

	.experience {
		padding: 2.5vw 4vw;
		background: url('/images/2.0/service/Agent-07.jpg') no-repeat center;
		background-size: cover !important;

		& > p {
			color: #fff;
			text-align: center;
			font-size: clamp(10px, 3.3vw, 66px);
			line-height: clamp(10px, 3.6vw, 70px);

			b {
				font-size: clamp(10px, 4.8vw, 96px);
				line-height: clamp(10px, 5.2vw, 102px);
			}
		}

		& > .row > div {
			& > p {
				color: #fff;
				font-size: clamp(10px, 2.1vw, 38px);
				line-height: clamp(10px, 2.5vw, 50px);

				& + p {
					font-size: clamp(min(24px, 3.8vw), 2.4vw, 44px);
					line-height: clamp(10px, 2.6vw, 52px);

					b {
						font-size: clamp(min(30px, 4.8vw), 3.4vw, 48px);
						line-height: clamp(10px, 8vw, 52px);
					}
				}
			}

			& > .row {
				padding: 0.9vw clamp(10px, 1vw, 20px);
				background-color: #fff;
				border-radius: 5px;

				b {
					font-size: clamp(10px, 2.1vw, 38px);
					line-height: clamp(10px, 2.6vw, 48px);
				}
				p {
					margin: clamp(5px, 1vw, 20px) 0 0 0;
					font-size: clamp(10px, 1vw, 20px);
					line-height: clamp(10px, 1.5vw, 30px);
				}
				&.flex-row-reverse p {
					margin-left: clamp(10px, 1vw, 20px);
				}
				&:not(.flex-row-reverse) p {
					margin-right: clamp(10px, 1vw, 20px);
				}
			}
		}
	}
}

.bg-red {
	background: rgb(237,28,36);
	// background: #ff0000;
}

.fade-in {
	transition: all 1.5s ease !important;
	transform: translateY(-100px);
  opacity: 0;
}
.fade-in-active {
	transform: translateY(0);
  opacity: 1;
}
</style>
